'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1.2.2';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/version.js
// module id = 282
// module chunks = 0